(function() {
    'use strict';

	angular.module( APP_ID )
	    .directive( 'contentSwitcher', ContentSwitcherDirective );


    /**
     * Toggle-based switcher between various kinds of content.
     *
     * @deprecated Old version of the switcher. Will be disestablished when
     * the app is fully updated to the new one.
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function ContentSwitcherDirective(){


        /** @type {ng.IDirective} */
        var directiveConfig = {
            restrict:     'E',
            scope:        {},
            controller:   'ContentSwitcherController',
            controllerAs: 'vm',
            templateUrl:  'app/views/partials/widgets/content-switcher.html',
            link:         Link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ////////////////////////////////////////////////////////////////////////



        /**
         * @param {ng.IScope} $scope
         * @param {ng.IElement} $element
         */
        function Link( $scope, $element, attrs, vm ){





            /* ===== PRIVATE MEMBERS ======================================== */


            /** Expecting `input[type=checkbox]` */
            var toggleInputElement = $element.find( '#content-toggle' );





            /* ===== EXPOSE TO THE SCOPE ==================================== */


            /**
             * Delegates wrapper link's click to an `input[checkbox]`'s click
             * to simulate real browser's behaviour and improve overal
             * accessibility.
             */
            $scope.clickToggle = function( $event ) {
                $event.preventDefault();
                toggleInputElement.change(); // Must be invoked to trigger `ng-change`
                return false;
            };





            /* ===== PRIVATE FUNCTIONS ====================================== */


            /**
             * Manually bound to work around dropped support of `click`
             * event and consequential 'change' event in Angular v1.7+
             *
             * See https://github.com/angular/angular.js/commit/656c8fa8f23b1277cc5c214c4d0237f3393afa1e for more
             */
            toggleInputElement.on( 'change', function () {
                vm.showDialog();
                return false;
            });


        }



    }
})();
